import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'

// @material-ui/core components
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Button, CircularProgress } from '@material-ui/core'
import { common } from '@material-ui/core/colors'

// core components

import buttonStyle from 'assets/jss/material-kit-react/components/buttonStyle'

const makeComponentStyles = makeStyles(() => ({
  ...buttonStyle,
  buttonProgress: {
    color: common.white[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -10,
  },
}))

type ButtonProps = {
  children: React.ReactNode
  color:
    | 'primary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'rose'
    | 'white'
    | 'facebook'
    | 'twitter'
    | 'google'
    | 'github'
    | 'transparent'
  size: 'sm' | 'lg'
  round?: boolean
  fullWidth?: boolean
  disabled?: boolean
  simple?: boolean
  block?: boolean
  link?: boolean
  justIcon?: boolean
  className?: string
  loading?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const RegularButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      color,
      round,
      fullWidth,
      disabled,
      simple,
      size,
      block,
      link,
      justIcon,
      className = '',
      loading = false,
      ...rest
    },
    ref
  ) => {
    const classes = makeComponentStyles()
    const btnClasses = classNames({
      [classes.button]: true,
      [classes[size]]: size,
      [classes[color]]: color,
      [classes.round]: round,
      [classes.fullWidth]: fullWidth,
      [classes.simple]: simple,
      [classes.block]: block,
      [classes.link]: link,
      [classes.justIcon]: justIcon,
      [className]: className,
    })
    return (
      <Button {...rest} disabled={disabled} ref={ref} className={btnClasses}>
        {children}
        {loading && (
          <CircularProgress
            size={20}
            className={classes.buttonProgress}
            disableShrink
          />
        )}
      </Button>
    )
  }
)

export default RegularButton
